export default "__VITE_ASSET__DCbH4Vbo__"